<template>
  <div class="headimg-container relative">
    <img :src="headimgurl" width="100" height="100" v-if="headimgurl">
    <img src="../../static/images/icon_shangchuantupian.png" width="30" height="30" class="absolute plus-btn">
    <uploadImage @readSuccess="uploadHeadimg"></uploadImage>
  </div>
</template>
<style lang="scss" scoped>
  .headimg-container{
    width: 100px;
    height: 100px;
    padding: 2px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
  }
  .uploadImg{
    width: 106px;
    height: 106px;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .plus-btn{
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -15px;
  }
</style>
<script>
import util from '../script/util'
import uploadImage from '../components/uploadImage.vue'
import {imageUpload} from '../api/api'
export default{
  props: {
    headimgurl: {
      type: String,
      default: ''
    },
    itype: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {

    }
  },
  components: {
    uploadImage
  },
  methods: {
    // 上传图片
    uploadHeadimg (base64) {
      let params = {
        icon: base64
      }
      if (this.itype !== 0) {
        params.itype = this.itype
      }
      imageUpload(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$emit('update:headimgurl', data.d.url)
          this.notifySuccess('上传成功')
        } else {
          this.notifyError('错误码：' + data.c + ',' + util.getErrorMsg(data.c))
        }
      }).catch(() => {
        this.notifyError('服务器大脑短路啦')
      })
    },
    // 失败提示
    notifyError (str) {
      this.$notify({
        title: '失败',
        message: str,
        type: 'error'
      })
    },
    // 成功
    notifySuccess (str) {
      this.$notify({
        title: '成功',
        message: str,
        type: 'success'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/uploadHeadImage.vue